<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.security_roles') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" size="sm" variant="success">{{ $t('roles.button.add') }}</b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('title.filters') }}
      </template>
      <template v-slot:content>
        <div class="filters sygni-grid">
          <div class="row">
            <div class="col-6">
              <filter-input
                  :filter-query="filterQuery"
                  filter-name="role"
                  filter-operator="like"
                  :label="$t('filters.label.search_role')"
                  :placeholder="$t('filters.placeholder.search_role')"
              >
              </filter-input>
            </div>
            <div class="col-6">
              <filter-select
                  :filter-query="filterQuery"
                  :options="categories"
                  :multiple="false"
                  options-label="text"
                  options-track-by="value"
                  filter-name="category"
                  :label="$t('filters.label.categories')"
                  :placeholder="$t('filters.placeholder.categories')"
                  >
              </filter-select>
            </div>
          </div>
        </div> <!-- #filters-->
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>
    <page-card>
      <template v-slot:header>
        {{ $t('title.list') }}
      </template>
      <template v-slot:content>
        <div v-required-role="'ROLE_BACKOFFICE_GROUP_GET'" class="sygni-grid">
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
          <div class="table-responsive">
            <b-table striped show-empty
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined
                     :sort-by.sync="orderColumn"
                     :sort-desc.sync="orderDirection"
                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">
              <template #cell(rolesCount)="data">
                <div class="ml-2">
                  {{ data.item.rolesCount }}
                </div>
              </template>
              <template #cell(isSpecial)="data">
                <div class="h6">
                  <b-badge pill :variant="data.item.isSpecial ? 'success' : 'danger'">{{
                      data.item.isSpecial
                    }}
                  </b-badge>
                </div>
              </template>
              <template #cell(createdAt)="data">
                <div>
                  {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}
                </div>
              </template>
              <template #cell(updatedAt)="data">
                <div>
                  {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button
                      variant="success" size="sm"
                      @click="openModal('create', data.item)"
                  >
                    {{$t('table.btn.edit')}}
                  </b-button>
                  <b-button
                      v-required-role="'ROLE_BACKOFFICE_GROUP_DELETE'"
                      variant="danger" size="sm"
                      @click="deleteItem(data.item)">
                    {{$t('table.btn.delete')}}
                  </b-button>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('state.loading')}}</strong>
                </div>
              </template>
            </b-table>
          </div> <!-- #table-responsive-->
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
        </div>
      </template>
      <template v-slot:footer>

      </template>
    </page-card>
  </div>
</template>

<script>
import FilterInput from "../../../../components/grid/filters/FilterInput";
import FilterSelect from "../../../../components/grid/filters/FilterSelect";
import GridMixin from '../../../../components/grid/GridMixin';
import CreateSecurityRoleModal from "./CreateSecurityRoleModal";
import ShowSecurityRoleModal from "./ShowSecurityRoleModal";
import axios from "axios";
import alertify from 'alertifyjs';
import PageHeader from "../../../../components/page/PageHeader";
import PageCard from "../../../../components/page/PageCard";
import GridPagination from "../../../../components/grid/grid-pagination/GridPagination";
import Vue from "vue";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    FilterInput,
    FilterSelect,
    GridPagination,
  },
  data() {
    return {
      gridGetUrl: '/api/role',
      orderColumn: 'createdAt',
      orderDirection: false,
      fields: [
        {key: 'role', label: this.$t('table.header.role'), sortable: true},
        {key: 'category', label: this.$t('table.header.category'), class: 'text-center', sortable: true},
        {key: 'isSpecial',label: this.$t('table.header.is_special'), class: 'text-center'},
        {key: 'createdAt', label: this.$t('table.header.created_at'), sortable: true, class: 'text-center'},
        {key: 'updatedAt', label: this.$t('table.header.updated_at'), sortable: true, class: 'text-center'},
        {key: 'actions',  label: this.$t('table.header.actions') }
      ],
      items: [],
      createModalInstance: null,
      showModalInstance: null,
      categories: []
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.$store.dispatch('administrator/getRoleCategories')
          .then(data => {
            this.categories = data.map(d => {
              return {text: d, value: d};
            })
          })
    },
    showItemDetails(roleName) {
      this.$refs['show-security-role-modal'].openModal(roleName);
    },
    editItem(item) {
      this.$refs['create-security-role-modal'].openModal(item);
    },
    deleteItem(role) {
      this.$bvModal.msgBoxConfirm('Role: ' + role.role, {
        title: 'Are you sure to delete role?',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        okVariant: 'danger'
      })
          .then(value => {
            if (value) {
              axios.delete(`/api/role/${role.role}`)
                  .then(() => {
                    this.loadItems();
                  })
                  .catch(() => {
                    alertify.error('Group can not be deleted! Remove users from group first.');
                  });
            }
          })
    },
    openModal(modalName, data) {
      let ModalConstructor;
      switch (modalName) {
        case('create'): {
          if (!this.createModalInstance) {
            ModalConstructor = Vue.extend(CreateSecurityRoleModal)
            this.createModalInstance = new ModalConstructor({parent: this});
            this.createModalInstance.$mount();
            this.createModalInstance.$on('savedRoles', this.loadItems);
          }
          this.createModalInstance.openModal(data);
          break;
        }
        case('show'): {
          if (!this.showModalInstance) {
            ModalConstructor = Vue.extend(ShowSecurityRoleModal)
            this.showModalInstance = new ModalConstructor({parent: this});
            this.showModalInstance.$mount();
          }
          this.showModalInstance.openModal(data);
          break;
        }
      }
    }
  },
  watch: {
    // showDeleted: function () {
    // this.loadItems();
    // }
  }
}
</script>
